import { createGlobalStyle } from 'styled-components';
import { ITheme } from '../interfaces/styled';

export interface GlobalStylesProps {
  theme: ITheme;
}

const GlobalStyles = createGlobalStyle<GlobalStylesProps>`
  html {
    scroll-behavior: smooth;
  }
  
  body {
    position: relative;
    font-family: ${({ theme }) => theme.family};
    font-size: ${({ theme }) => theme.fontSize.sm}px;
    font-weight: 450;
    color: ${({ theme }) => theme.colors.text};
    line-height: 1.2;
    background: ${({ theme }) => theme.colors.bg};
    margin: 0;
  }
`;

export { GlobalStyles };
